import { useState, useEffect } from "react";
import { APP_LANGUAGES } from './constants';

export function parseLanguage(detectLanguage: string) {
  const language = detectLanguage.split('-')[0];
  return APP_LANGUAGES[language] ? language : 'en';
}

export function convertToLocaleDateString(date: string|number, language: string) {
  if (typeof date === 'string') {
    date = Number(date);
  }
  return new Date(date).toLocaleDateString(language,  
      {month: '2-digit', year: 'numeric', day: '2-digit'}
  );
}

export function useDebounce(value: any, delay = 500) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

export function LocalizedDate(userLocale: string, date?: Date ){
  if (!date || !userLocale) 
    return "";
  const createdDate = date;
  let locale = userLocale ;
  let localisedDate = ''; 
  let localizedDateOut = '';
  if ( navigator.language.substring(0,2) === 'en' && locale === 'en' )
    locale =  navigator.language
  if (navigator.language.substring(0,2) !== 'en' && locale === 'en')
      locale = 'en-GB';
  if (navigator.language.substring(0,2) === 'th' || locale === 'th')
      locale = 'en-GB';  
 
  localisedDate = createdDate.toLocaleDateString(locale,  {year: "numeric", month: "2-digit",  day: "2-digit"});
  localizedDateOut = localisedDate;
  if (locale === 'en-ZA' )
    localizedDateOut= localisedDate.replace(/\//g, "-");
  // console.log("localeUI: " + userProfile.locale + " localeBrowser:" + navigator.language + " selectedLocale: " + locale + " localisedDate to: " + localizedDateOut) 
  return localizedDateOut;
}
